import {
    TransactionView,
    TransactionViewSchema,
} from "@common/types/views/transactionViews";
import { NamedView } from "@common/types/views/views";
import {
    useWorkspaceUserCache,
    WORKSPACE_USER_CACHE_KEYS,
} from "@hooks/useWorkspaceUserCache";
import {
    ResolvedTransactionsPageOpeningView,
    resolveTransactionsPageOpeningView,
} from "./resolveTransactionsPageOpeningView";
import { useTransactionsPageDefaultView } from "./useTransactionsPageDefaultView";

interface TransactionsPageOpeningView extends ResolvedTransactionsPageOpeningView {
    defaultView: NamedView<TransactionView> | undefined;
}

// The caches are read once per mount, so the page must call this below its
// keyed table provider for every remount to see the id the toolbar saved.
export function useTransactionsPageOpeningView(): TransactionsPageOpeningView {
    const defaultView = useTransactionsPageDefaultView();
    const [savedBaseViewId] = useWorkspaceUserCache<string | null>(
        WORKSPACE_USER_CACHE_KEYS.TRANSACTIONS_PAGE_BASE_VIEW_ID_CACHE_KEY,
    );
    const [cachedView] = useWorkspaceUserCache<TransactionView>(
        WORKSPACE_USER_CACHE_KEYS.TRANSACTIONS_PAGE_VIEW_CACHE_KEY,
        TransactionViewSchema,
    );

    return {
        defaultView,
        ...resolveTransactionsPageOpeningView({
            savedBaseViewId,
            cachedView,
            defaultView,
        }),
    };
}
